var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.90909C16 1.30244 14.6976 0 13.0909 0H2.90909C1.30244 0 0 1.30244 0 2.90909V13.0909C0 14.6976 1.30244 16 2.90909 16H13.0909C14.6976 16 16 14.6976 16 13.0909V2.90909ZM2.18182 4.36364L2.90909 3.63636L3.63636 4.36364L5.09091 2.90909L5.81818 3.63636L3.63636 5.81818L2.18182 4.36364ZM2.18182 8L2.90909 7.27273L3.63636 8L5.09091 6.54545L5.81818 7.27273L3.63636 9.45455L2.18182 8ZM2.90909 10.9091L2.18182 11.6364L3.63636 13.0909L5.81818 10.9091L5.09091 10.1818L3.63636 11.6364L2.90909 10.9091ZM13.8182 3.63636H7.27273V5.09091H13.8182V3.63636ZM7.27273 7.27273H13.8182V8.72727H7.27273V7.27273ZM13.8182 10.9091H7.27273V12.3636H13.8182V10.9091Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistFilter);
export default __webpack_public_path__ + "static/media/ChecklistFilter.3af0ece82209c80bf44eb86330a4e636.svg";
export { ForwardRef as ReactComponent };